module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OR ALL THE")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLLYWOOD")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IVES")])])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "ded1"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Old and new . . . male and female . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Gay and straight . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("A constant source of inspiration!")])]), _vm._v(" "), _c('p', {
    staticClass: "ded3"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("And for A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RNOLD")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OPELSON")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("who told me much more than I")])]), _vm._v(" "), _c('p', {
    staticClass: "ded4"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("ever wanted to know!")])]), _vm._v(" "), _c('p', {
    staticClass: "ded5"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("And for F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RANK")]), _vm._v(",")])])]), _c('p', {
    staticClass: "ded5"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Always . . .")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561e2c79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0